import { countries } from "./countries.js";

(() => {
    const { createApp, reactive, watch, ref, onMounted, computed } = Vue;

    const aroundTheWorldState = reactive({
        country: {
            id: 'usa',
            name: 'United States Of America',
            amount_sold: 0,
        }
    });

    const metaDataElement = document.getElementById('around-the-world-data');
    const global_map = ref(null);
    let global_map_view_box = null;

    const selectCountryByMapElement = (event) => {
        const map_element = event.target;
        const selected_element_country_id = map_element.getAttribute('data-country-id');
        if (selected_element_country_id && isValidCountryId(selected_element_country_id)) {
            updateCountryId(selected_element_country_id);
        }
    }

    const highlightCountry = () => {
        clearHighlights();
        const country_elements = document.querySelectorAll(`[data-country-id=` + aroundTheWorldState.country.id + `]`);

        if (!global_map.value || !isValidCountryId(aroundTheWorldState.country.id)) return;

        country_elements.forEach(country => {
            global_map.value.appendChild(country);
            country.classList.add('around-the-world__active-country');
        });
    }

    const clearHighlights = () => {
        const highlighted_country = document.querySelectorAll('.around-the-world__active-country');
        highlighted_country.forEach(country => country.classList.remove('around-the-world__active-country'));
    }

    const scrollCountryIntoView = () => {
        if (!isValidCountryId(aroundTheWorldState.country.id)) return;
        const { id } = aroundTheWorldState.country;
        const scroll_element = document.getElementById('around-the-world__map-container');
        const country = document.getElementById(id);
    
        if (!country || !scroll_element) return;
    
        const { scrollX, scrollY } = calculateCountryScrollOrigin(country, scroll_element);
    
        scroll_element.scrollTo({ left: scrollX, top: scrollY, behavior: 'smooth' });
    };
    
    const calculateCountryScrollOrigin = (country, scroll_element) => {
        const { x, y, width, height } = getSelectedCountryBBox(country);
        const x_percent = (x + width / 2) / global_map_view_box.width;
        const y_percent = (y + height / 2) / global_map_view_box.height;
    
        return {
            scrollX: scroll_element.scrollWidth * x_percent - scroll_element.clientWidth / 2,
            scrollY: scroll_element.scrollHeight * y_percent - scroll_element.clientHeight / 2
        };
    };
    
    const getSelectedCountryBBox = (country) => country?.getBBox() ?? { x: 0, y: 0, width: 0, height: 0 };    

    const isValidCountryId = (id) => {
        return countries.some(country => country.id === id);
    };

    const updateCountryId = (country_id) => {
        if (!isValidCountryId(country_id)) return;
        aroundTheWorldState.country.id = country_id;
    }

    const updateCountryName = () => {
        if (!isValidCountryId(aroundTheWorldState.country.id)) return;
        const country = countries.find(country => country.id === aroundTheWorldState.country.id)
        aroundTheWorldState.country.name = country.name;
    };

    const updateAmountSold = () => {
        if (!isValidCountryId(aroundTheWorldState.country.id)) return;
        const selected_country = JSON.parse(metaDataElement.textContent).json.countries.find(country => country.country_variant_title === aroundTheWorldState.country.id);
        if(selected_country) {
            aroundTheWorldState.country.amount_sold = selected_country.quantity;
        } else {
            aroundTheWorldState.country.amount_sold = 0;
        }
    };

    const addClickablePathClass = () => {
        countries.forEach(({ id }) => {
            const elements = document.querySelectorAll(`[data-country-id="${id}"]`);
            elements.forEach(element => {
                element.classList.add('around-the-world__clickable-path');
            });
        });
    };

    const getCandleUrl = computed(() => {
        const selected_country = countries.find(country => country.id === aroundTheWorldState.country.id);
        return selected_country
          ? `/products/around-the-world-my-way-candle?variant=${selected_country.variant_id}`
          : '#';
      });

    const aroundTheWorldApp = createApp({
        name: "aroundTheWorldApp",
        setup() {

            onMounted(() => {
                global_map.value = document.getElementById("global_map");
                global_map_view_box = global_map.value.viewBox.baseVal;
                addClickablePathClass();
                highlightCountry();
                scrollCountryIntoView();
                updateAmountSold();
            });

            watch(() => aroundTheWorldState.country.id, updateCountryName);
            watch(() => aroundTheWorldState.country.id, updateAmountSold);
            watch(() => aroundTheWorldState.country.id, scrollCountryIntoView);
            watch(() => aroundTheWorldState.country.id, highlightCountry);
            
            return {
                aroundTheWorldState,
                countries,
                getCandleUrl,
                selectCountryByMapElement,
            };
        },
        delimiters: ["${", "}"],
    });

    aroundTheWorldApp.mount("#aroundTheWorldApp");
})();